import { createInstance, MatomoProvider } from "@datapunt/matomo-tracker-react";
import { useAuth, useCookieConsent } from "@myplant-io/hooks";
export { useMatomo } from "@datapunt/matomo-tracker-react";
import { PropsWithChildren, useEffect, useState } from "react";
import { API_BASE_URL } from "../constants";

type MatomoOptions = {
  urlBase: string;
  siteId: number;
  linkTracking?: boolean;
  userId?: string;
};

export function createMatomoClient(options: MatomoOptions) {
  return createInstance({
    linkTracking: false, // optional, default value: true
    ...options,
  });
}

export function TrackingProvider({ children }: PropsWithChildren<unknown>) {
  const { cookieConsent } = useCookieConsent();
  const didConsent = cookieConsent.includes("analytics");
  const { data: authData } = useAuth(API_BASE_URL)
  const user = authData?.user
  const [client, setClient] = useState<ReturnType<typeof createInstance>>(
    createMatomoClient({
      urlBase: "https://usageanalytics.myplant.io",
      siteId: 68,
      userId: user?.name,
    })
  );

  useEffect(() => {
    if (user && didConsent) {
      setClient(
        createMatomoClient({
          urlBase: "https://usageanalytics.myplant.io",
          siteId: 68,
          userId: user.name,
        })
      );
    }
  }, [user, didConsent]);

  if (!didConsent) {
    return <>{children}</>;
  }

  if (!client) {
    return null;
  }

  { /* @ts-expect-error MatomoProvider types outdated */ }
  return <MatomoProvider value={client}>{children}</MatomoProvider>;
}
